export default {"src":"/_next/static/media/wb.fb9ce2f8.svg","height":44,"width":76,"blurWidth":0,"blurHeight":0};